import { View, StyleSheet } from 'react-native';
import { Card, Paragraph } from 'react-native-paper';
import { ComponentProps } from 'react';

export type ErrorDisplayProps = {
  title?: string;
  message?: string;
} & Pick<ComponentProps<typeof View>, 'testID' | 'children' | 'style'>;

export const ErrorDisplay = ({
  testID = 'error-display',
  title = 'Oops!  Something went wrong.',
  message = 'Please try again later.',
  ...props
}: ErrorDisplayProps) => {
  const styles = StyleSheet.create({
    screenContainer: {
      flex: 1,
      justifyContent: 'center',
    },
    messageContainer: {
      alignItems: 'center',
      justifyContent: 'center',
    },
  });

  return (
    <View testID={testID} style={[styles.screenContainer, props.style]}>
      <View style={styles.messageContainer}>
        <Card testID={`${testID}-card`}>
          <Card.Title title={title} testID={`${testID}-title`} />
          <Card.Content testID={`${testID}-content`}>
            <Paragraph testID={`${testID}-message`} style={{ margin: 10 }}>
              {message}
            </Paragraph>
            {props.children}
          </Card.Content>
        </Card>
      </View>
    </View>
  );
};
